var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.0546 4.646H15.9454C8.51373 4.646 4.08331 9.07641 4.08331 16.5081V33.5968C4.08331 41.0489 8.51373 45.4793 15.9454 45.4793H33.0341C40.4658 45.4793 44.8962 41.0489 44.8962 33.6172V16.5081C44.9166 9.07641 40.4862 4.646 33.0546 4.646ZM34.2591 20.3668L22.6829 31.9431C22.3971 32.2289 22.0091 32.3922 21.6008 32.3922C21.1925 32.3922 20.8046 32.2289 20.5187 31.9431L14.7408 26.1652C14.1487 25.5731 14.1487 24.5931 14.7408 24.001C15.3329 23.4089 16.3129 23.4089 16.905 24.001L21.6008 28.6968L32.095 18.2027C32.6871 17.6106 33.6671 17.6106 34.2591 18.2027C34.8512 18.7947 34.8512 19.7543 34.2591 20.3668Z",
    fill: "#F3F3F3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickSquare);
export default __webpack_public_path__ + "static/media/tick-square.51a9f8b86cc9e260dc5b8dd4fd70ce41.svg";
export { ForwardRef as ReactComponent };